module.exports = __webpack_public_path__ + "static/media/seguros-mundial-pin.9bef7a61.svg";